export default "__VITE_ASSET__BgVU9P0I__"